import apiChange from '../apiChange';

import { ParamsBodyChooseQuoteItems, ParamsDataChooseQuoteItems } from 'utils/typeServices';

type response = {
    errorCode: null;
    message: string;
    success: boolean;
    data: ParamsDataChooseQuoteItems;
}

export const PostChooseQuoteItems = async ({ body }: { body: ParamsBodyChooseQuoteItems }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeservice/chooseQuoteItems/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
